<template>
    <div class="top-bar">
        <div style="width: 10%">
            <div style="color: white; font-size: 20px; font-weight: bold">{{ $t("title") }}</div>
        </div>
        <div style="width: 70%"></div>
        <div style="width: 20%">
            <div
                style="
                    display: flex;
                    align-items: center;
                    float: right;
                    margin-top: 5px;
                    color: white;
                    font-size: 15px;
                    font-weight: bold;
                "
            >
                <div style="margin-right: 8px">{{ loggedInUserId }} 님</div>
                <NButton quaternary style="color: white" v-on:click="handleLogout()">
                    <template #icon>
                        <NIcon size="25"><LogOutIcon /></NIcon>
                    </template>
                </NButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { useAuth } from "@/composables/useAuth";
import { NIcon, NButton } from "naive-ui";
import { LogOutOutline as LogOutIcon } from "@vicons/ionicons5";
const { loggedInUserId, handleLogout } = useAuth();

watch(loggedInUserId, () => {
    console.log(`TopBar : ${loggedInUserId.value}`);
});
</script>

<style scoped>
.top-bar {
    width: 100%;
    height: 75px;
    display: flex;
    background-color: rgb(23, 53, 80);
    justify-content: space-between;
    align-items: center;
    padding: 0 40px 0 30px;
    box-sizing: border-box;
}
</style>
